import { withStyles, WithStyles } from '@material-ui/core'

const styles = () => ({
  container: {
    margin: '8px 0px 8px'
  }
})

interface FieldContainerProps extends WithStyles {
  children: any
}

const FieldContainer = ({ children, classes }: FieldContainerProps) => (
  <div className={classes.container}>{children}</div>
)

export default withStyles(styles)(FieldContainer)
